export default "__VITE_ASSET__BBTrpO4t__"